import React, { Component } from 'react';
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import Api from "context/api";

// Supported widgets
import GraphViewV1Widget from "widgets/v1/graphView/index";
// Demos
import GraphViewV1SimpleDemo from "demos/graphViewV1Basic/index";

// React Router v6 no longer injects router props; this wrapper supplies the
// route param (itemId) to the class-based widget.
function GraphViewV1WidgetRoute({ app }) {
  const { itemId } = useParams();
  return <GraphViewV1Widget app={app} itemId={itemId} />;
}

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authenticated: false,
      auth: null,
      api: null
    };

    this.state.api = new Api(
      this.state,
      (state) => { this.setState(state) },
      () => { return this.state });
  }

  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/v1/graph-view/:itemId"
            element={<GraphViewV1WidgetRoute app={this.state} />}
          />

          <Route path="/demos/v1/graph-view/simple"
            element={<GraphViewV1SimpleDemo app={this.state} />}
          />
        </Routes>
      </BrowserRouter>
    );
  }
}
